/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Unicode character inspector. Break text into characters and see each one's code point, Unicode value, and UTF-8 bytes. Runs in your browser.`)
};

const es_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de caracteres Unicode gratuito. Divide el texto en caracteres y ve el punto de código, valor Unicode y bytes UTF-8 de cada uno. Se ejecuta en tu navegador.`)
};

const de_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Unicode-Zeichen-Inspektor. Zerlegen Sie Text in einzelne Zeichen und sehen Sie den Codepunkt, den Unicode-Wert und die UTF-8-Bytes jedes einzelnen. Läuft direkt in Ihrem Browser.`)
};

const nl_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Unicode-karakterinspecteur. Breek tekst op in karakters en zie het codepunt, Unicode-waarde en UTF-8-bytes van elk karakter. Draait in je browser.`)
};

const fr_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur Unicode gratuit. Décomposez le texte en caractères et consultez le point de code, la valeur Unicode et les octets UTF-8 de chacun. Fonctionne dans votre navigateur.`)
};

const it_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore gratuito di caratteri Unicode. Dividi il testo in caratteri e visualizza il punto di codice, il valore Unicode e i byte UTF-8 di ciascuno. Funziona nel tuo browser.`)
};

const pt_br2_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor Unicode de caracteres gratuito. Divida o texto em caracteres e veja o ponto de código, o valor Unicode e os bytes UTF-8 de cada um. Funciona no seu navegador.`)
};

const pt_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de caracteres Unicode gratuito. Divida o texto em caracteres e veja o ponto de código, o valor Unicode e os bytes UTF-8 de cada um. Funciona no seu navegador.`)
};

const ja_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「無料の Unicode 文字インスペクタ。テキストを文字に分割し、各文字のコードポイント、Unicode 値、UTF-8 バイトを確認できます。ブラウザで実行されます。」`)
};

const zh_ci_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 Unicode 字符检查器。将文本拆分为单个字符，查看每个字符的码点、Unicode 值和 UTF-8 字节。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_tool_description", locale)
	if (locale === "en") return en_ci_tool_description(inputs)
	if (locale === "es") return es_ci_tool_description(inputs)
	if (locale === "de") return de_ci_tool_description(inputs)
	if (locale === "nl") return nl_ci_tool_description(inputs)
	if (locale === "fr") return fr_ci_tool_description(inputs)
	if (locale === "it") return it_ci_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ci_tool_description(inputs)
	if (locale === "pt") return pt_ci_tool_description(inputs)
	if (locale === "ja") return ja_ci_tool_description(inputs)
	return zh_ci_tool_description(inputs)
};